// src/screens/LoanDrilldownScreen/tabs/LoanDrilldownFilesTab/LoanFilesTable/LoanFilesTable.jsx
import { ModuleRegistry } from "ag-grid-community";
import {
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MultiFilterModule,
  PivotModule,
  RowGroupingModule,
  RowGroupingPanelModule,
  SetFilterModule,
  SideBarModule,
  TreeDataModule,
} from "ag-grid-enterprise";
import { AgGridReact } from "ag-grid-react";
import { useMemo, useRef } from "react";

import isEmpty from "lodash/isEmpty";

import { columnTypesDate } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesDate";
import { columnTypesDollar } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesDollar";
import { columnTypesNumber } from "../../../_src_shared/utils/agGrid/columnTypes/columnTypesNumber";
import { useSidebar } from "../../../_src_shared/utils/agGrid/hooks/useSidebar";
import AgGridTableWrapper from "../../../components/agGrid/AgGridTableWrapper";
import { useColumnDefs } from "./hooks/useColumnDefs";

ModuleRegistry.registerModules([
  SideBarModule,
  RowGroupingPanelModule,
  MultiFilterModule,
  RowGroupingModule,
  PivotModule,
  TreeDataModule,
  FiltersToolPanelModule,
  ColumnsToolPanelModule,
  SetFilterModule,
]);

const LoanSizerFilesTable = ({
  rowData,
  autoHeight,
  quickFilter,
  height = "100%",
}) => {
  const gridRef = useRef(null);

  const columnDefs = useColumnDefs();

  const columnTypes = useMemo(() => {
    return {
      ...columnTypesDate(),
      ...columnTypesNumber(),
      ...columnTypesDollar(),
    };
  }, []);

  const sidebar = useSidebar();

  if (isEmpty(rowData)) {
    return null;
  }

  return (
    <AgGridTableWrapper height={height} simpleTable size={4}>
      <AgGridReact
        ref={gridRef}
        rowData={rowData}
        columnDefs={columnDefs}
        columnTypes={columnTypes}
        singleClickEdit
        sideBar={sidebar}
        quickFilterText={quickFilter}
        domLayout={autoHeight ? "autoHeight" : "normal"}
      />
    </AgGridTableWrapper>
  );
};

export default LoanSizerFilesTable;
